import { Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-brand-black text-white relative overflow-hidden">
            <div className="absolute inset-0 opacity-[0.04]">
                <div className="absolute -top-20 -right-20 w-96 h-96 rounded-full bg-brand-gold blur-3xl" />
            </div>

            <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-20">
                <div className="grid md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="mb-6">
                            <div className="font-serif text-3xl tracking-tight">SheFleet</div>
                            <div className="text-[10px] tracking-[0.3em] uppercase text-brand-gold mt-1">
                                Transportation LLC
                            </div>
                        </div>
                        <p className="font-serif text-xl leading-relaxed text-white/80 max-w-md">
                            Medical courier services built on trust. Delivered with precision —
                            one mile, one mission, one community at a time.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <div className="text-[10px] tracking-[0.3em] uppercase text-brand-gold mb-5">
                            Navigate
                        </div>
                        <ul className="space-y-3 text-sm text-white/75">
                            <li><a href="#about" className="hover:text-brand-gold transition-colors">About</a></li>
                            <li><a href="#services" className="hover:text-brand-gold transition-colors">Services</a></li>
                            <li><a href="#service-area" className="hover:text-brand-gold transition-colors">Service Area</a></li>
                            <li><a href="#contact" className="hover:text-brand-gold transition-colors">Contact</a></li>
                            <li><a href="/admin/login" className="hover:text-brand-gold transition-colors">Admin Login</a></li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <div className="text-[10px] tracking-[0.3em] uppercase text-brand-gold mb-5">
                            Connect
                        </div>
                        <ul className="space-y-4 text-sm text-white/80">
                            <li className="flex items-start gap-3">
                                <Mail size={16} className="mt-1 text-brand-gold shrink-0" />
                                <a href="mailto:dispatch@shefleettransportation.com" className="hover:text-brand-gold">
                                    dispatch@shefleettransportation.com
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <Phone size={16} className="mt-1 text-brand-gold shrink-0" />
                                <a href="tel:+16362502650" className="hover:text-brand-gold">
                                    (636) 250-2650
                                </a>
                            </li>
                            <li className="flex items-start gap-3">
                                <MapPin size={16} className="mt-1 text-brand-gold shrink-0" />
                                <span>Greater St. Louis, MO &amp; Southern IL</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
                    <div>
                        © {new Date().getFullYear()} SheFleet Transportation LLC. All rights reserved.
                    </div>
                    <div className="tracking-[0.2em] uppercase text-brand-gold/80">
                        Women-Owned · Locally Driven
                    </div>
                </div>
            </div>
        </footer>
    );
}
